// frontend/src/api/orders.js
import { apiClient } from './index';

const ordersApi = {
  /**
   * Fetch user's order history (Customer View)
   */
  getUserOrders: async () => {
    return await apiClient.get('/orders/');
  },

  /**
   * Create a new order
   */
  createOrder: async (orderData) => {
    return await apiClient.post('/orders/', orderData);
  },

  /**
   * Customer confirms receipt of goods (Releases Escrow)
   */
  confirmDelivery: async (orderId) => {
    return await apiClient.put(`/orders/${orderId}/confirm`, {});
  },

  /**
   * Archive an order (Hide from user view)
   */
  archiveOrder: async (orderId) => {
    return await apiClient.put(`/orders/${orderId}/archive`, {});
  },

  cancelOrder: async (orderId) => {
    return await apiClient.put(`/orders/${orderId}/cancel`, {});
  },

  /**
   * Fetch ALL orders (Admin/Manager View)
   */
  getAllOrdersAdmin: async () => {
    return await apiClient.get('/orders/admin/all');
  },

  /**
   * Update order status (Admin/Manager)
   */
  updateOrderStatus: async (orderId, status, trackingNumber = null) => {
    return await apiClient.put(`/orders/admin/${orderId}/status`, { 
      status, 
      tracking_number: trackingNumber 
    });
  },

  /**
   * Update Logistics / Waybill (Seller Fulfillment)
   */
  updateLogistics: async (orderId, data) => {
    return await apiClient.put(`/orders/${orderId}/logistics`, data);
  },

  /**
   * Update Internal Note (Admin Only)
   */
  updateOrderNote: async (orderId, note) => {
    return await apiClient.put(`/orders/admin/${orderId}/note`, { note });
  },

  /**
   * Bulk Update Status (Admin Only)
   */
  bulkUpdateStatus: async (orderIds, status) => {
    return await apiClient.put('/orders/admin/bulk-status', { 
      order_ids: orderIds, 
      status 
    });
  },

  /**
   * Bulk Delete Orders (SUPER ADMIN ONLY)
   */
  deleteOrdersAdmin: async (orderIds) => {
    return await apiClient.delete('/orders/admin/delete', { 
        body: { order_ids: orderIds } 
    });
  },

  /**
   * Download Invoice PDF
   */
  downloadInvoice: async (orderId) => {
    const token = localStorage.getItem('accessToken');
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/orders/${orderId}/invoice`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to download invoice");
    }
    
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Invoice_${orderId}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
};

export { ordersApi };